<div *ngIf="router.url === '/inproeco/estado/instalaciones'">
  
  <app-nav-bar></app-nav-bar>
</div>
<div *ngIf="router.url === '/inproeco/estado/clientes'">
 
  <app-nav-bar></app-nav-bar>
</div>
<div *ngIf="router.url === '/inproeco/estado/centros'">
  
  <app-nav-bar></app-nav-bar>
</div>
<div *ngIf="router.url === '/inproeco/estado/contratistas'">
 
  <app-nav-bar></app-nav-bar>
</div>
<div *ngIf="router.url === '/inproeco/estado/gestores'">
 
  <app-nav-bar></app-nav-bar>
</div>
<div *ngIf="router.url === '/inproeco/estado/transportistas'">
 
  <app-nav-bar></app-nav-bar>
</div>
<div *ngIf="router.url === '/inproeco/estado'">
  <h1>Entidad / Estado</h1>
</div>
<div *ngIf="router.url === '/inproeco/estado/documentacion-caducada'">

  <app-nav-bar></app-nav-bar>
</div>
<div *ngIf="router.url === '/inproeco/estado/documentacion-proxima'">
  
  <app-nav-bar></app-nav-bar>
</div>
<div *ngIf="router.url === '/inproeco/estado/pendientes'">
 
  <app-nav-bar></app-nav-bar>
</div>
<div *ngIf="router.url === '/inproeco/estado/adicional-pendientes'">
 
  <app-nav-bar></app-nav-bar>
</div>

<div *ngIf="router.url === '/inproeco/usuarios'">
  <h1 class="headerUsuarios">Usuarios</h1>
</div>
